import React, { useEffect, useState } from "react";
import "./Reactions.css";
import { getPostLikeHistory } from "../../../api/ApiConfig";

const emojiList = [
  { id: "heart", emoji: "❤️" },
  { id: "smile", emoji: "😊" },
  { id: "like", emoji: "👍" },
  { id: "celebrate", emoji: "🎉" },
  { id: "clap", emoji: "👏" },
];

export default function ReactionPopup({ postId, onClose }) {
  const [reactionData, setReactionData] = useState({});
  const [selectedReaction, setSelectedReaction] = useState("All");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReactionData = async () => {
      setIsLoading(true);
      try {       
        const response = await getPostLikeHistory({posts_id : postId});
        setReactionData(response?.data || {});
      } catch (err) {
        setReactionData({});
      } finally {
        setIsLoading(false);
      }
    };

    fetchReactionData();
  }, [postId]);

  const getReactions = () => {
    if (selectedReaction === "All") {
      return Object.entries(reactionData).flatMap(([type, val]) =>
        val.reactions.map((r) => ({
          ...r,
          emoji: emojiList.find((e) => e.id === type)?.emoji,
        }))
      );
    } else {
      const data = reactionData[selectedReaction];
      return data?.reactions?.map((r) => ({
        ...r,
        emoji: emojiList.find((e) => e.id === selectedReaction)?.emoji,
      })) || [];
    }
  };

  const getReactionCount = (id) => reactionData[id]?.count || 0;

  return (
    <div className="reaction-modal-backdrop">
      <div className="reaction-modal">
        <div className="modal-header">
          <h5>Reactions</h5>
          <button className="close-btn" onClick={onClose}>
            ✖
          </button>
        </div>

        <div className="reaction-tabs">
          <button
            className={selectedReaction === "All" ? "active" : ""}
            onClick={() => setSelectedReaction("All")}
          >
            All {getReactions().length}
          </button>
          {emojiList.map(
            (e) =>
              getReactionCount(e.id) > 0 && (
                <button
                  key={e.id}
                  className={selectedReaction === e.id ? "active" : ""}
                  onClick={() => setSelectedReaction(e.id)}
                >
                  {e.emoji} {getReactionCount(e.id)}
                </button>
              )
          )}
        </div>

        <div className="reaction-users">
          {getReactions().map((user, i) => (
            <div className="reaction-user" key={i}>
              <div className="avatar">{user.emp_name?.[0]}</div>
              <div className="info">
                <div className="name">{user.emp_name}</div>
                <div className="subtext">{user.reacted_on}</div>
              </div>
              <div className="emoji">{user.emoji}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
